import '../css/Latest-work.css';
import {works} from '../data/works';

const LatestWork = () => {
    return (<div className='latest-work-div'>
        <h2>Latest Work</h2>
        <div className='work-elements'>

            {
                works.map((work) => {
                    var projectName = work.projectName;
                    return (                    
                    <div key={work.id} className='project'>
                        <h3>{work.projectName}</h3>
                        <div className='description'>
                            <p>{work.description}</p>
                            <div className='work-icons'>
                                <a href={work.dribbbleLink}><img src={require('../assets/work/dribbble-icon.png')} alt='dribbble'/></a>
                                <a href={work.codepenLink}><img src={require('../assets/work/codepen-icon.png')} alt='codepen'/></a>
                            </div>
                        </div>
                        <div className='work-img'>
                            
                            <img src={require(`../assets/work/${projectName}.png`)} alt={projectName}/>
                        </div>
                    </div>
                   

                );})
            }
            </div></div>

);
}

export default LatestWork;